import { useAuth } from '../../public/site/AuthProvider';

export const useRolePermissions = () => {
  const { rolesAndPermissions, hasPermission } = useAuth();
  return {
    capabilities: rolesAndPermissions?.capabilities ?? null,
    metadata: rolesAndPermissions?.metadata ?? null,
    hasPermission,
    loading: false,
  };
};
